import React from 'react';

export const Close = ({}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.4316 6.70518C18.7455 6.39127 18.7455 5.88231 18.4316 5.56839C18.1177 5.25448 17.6087 5.25448 17.2948 5.5684L12 10.8632L6.70518 5.5684C6.39126 5.25448 5.88231 5.25448 5.56839 5.56839C5.25448 5.88231 5.25448 6.39126 5.56839 6.70518L10.8632 12L5.56839 17.2948C5.25448 17.6088 5.25448 18.1177 5.56839 18.4316C5.88231 18.7455 6.39126 18.7455 6.70518 18.4316L12 13.1368L17.2948 18.4316C17.6087 18.7455 18.1177 18.7455 18.4316 18.4316C18.7455 18.1177 18.7455 17.6088 18.4316 17.2948L13.1368 12L18.4316 6.70518Z" fill="white"/>
        </svg>
    )
};
